import React, { Component } from "react";
import queryString from "query-string";

import styled from "styled-components";
import { Button, Card, CardBody, Col, Container, Row, Form } from "reactstrap";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import RemoteTable from "../../../../components/Common/RemoteTable";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  addPosition,
  getPositionsList,
  deletePosition,
  getGroups,
  patchPositions,
  getPositionsById,
} from "../../../../store/positions/actions";
import ModalPositions from "../EditPositions/ModalPositions";
import { INITIAL_DATA_PARAMS } from "../../../../constants/store";
import ModifiedMetaTags from '../../../../components/ModifiedMetaTags/index';

class PositionsList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      filter_name: [],
      deleteAlert: null,
      viewAddPosition: false,
      editData: null,
    };

    this.searchTimer = null;
  }

  componentDidMount() {
    this.props.getPositionsList({
      ...INITIAL_DATA_PARAMS,
    });
    this.props.getGroups();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { data } = this.props;
  }

  componentWillUnmount() {
    this.setState({
      selectedPosition: {
        results: [],
      },
    });
  }

  handleTableChange = data => {
    this.props.getPositionsList(data);
  };

  handleChangeDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  viewAddPositionModal = () => {
    this.setState(prevState => ({
      viewAddPosition: !prevState.viewAddPosition,
      editData: null,
    }));
  };

  render() {
    const onClickRow = (e, row, type) => {
      if (this.props.permissions?.["view_positionmodel"]) {
        this.setState(prevState => ({
          viewAddPosition: !prevState.viewAddPosition,
          editData: type === "edit" ? row : null,
        }));
      }
    };

    const legalNameFormatter = (cell, row, label) => {
      return (
        <LegalNameLink onClick={e => onClickRow(e, row, "edit")}>
          {row[label]}
        </LegalNameLink>
      );
    };

    const actionsFormatter = (cell, row) => {
      const onClickDelete = () => {
        this.handleChangeDeleteAlert({
          title: `Delete "${row.title}"!`,
          onConfirm: () => {
            this.props.deletePosition(row.id, {
              ...this.props.data,
              page:
                this.props.data.results.length === 1 ? 1 : this.props.data.page,
            });
            this.handleChangeDeleteAlert(null);
            this.setState({
              selectedFilter: null,
            });
          },
        });
      };

      return (
        <>
          {this.props.permissions?.["change_positionmodel"] && (
            <button
              type="button"
              className="btn btn-primary  btn-sm"
              onClick={e => onClickRow(e, row, "edit")}
            >
              <i className="mdi mdi-circle-edit-outline d-block font-size-16" />
            </button>
          )}
          {this.props.permissions?.["delete_positionmodel"] && (
            <button
              type="button"
              className="btn btn-danger btn-sm m-1"
              onClick={onClickDelete}
            >
              <i className="mdi mdi-trash-can d-block font-size-16" />
            </button>
          )}
        </>
      );
    };

    const columns = [
      {
        dataField: "title",
        text: "Title",
        sort: true,
        formatter: (cell, row) => legalNameFormatter(cell, row, "title"),
      },
      {
        dataField: "description",
        text: "Description",
        sort: true,
        formatter: (cell, row) => legalNameFormatter(cell, row, "description"),
      },
      // {
      //   dataField: "rate",
      //   text: "Rate $",
      //   sort: true,
      //   formatter: (cell, row) => legalNameFormatter(cell, row, "rate"),
      // },
      // {
      //   dataField: "groups",
      //   text: "Permissions groups",
      //   sort: true,
      //   formatter: (cell, row) => legalNameFormatter(cell, row, "groups"),
      // },
      {
        dataField: "actions",
        text: "Actions",
        sort: false,
        formatter: actionsFormatter,
      },
    ];

    return (
      <React.Fragment>
        {this.state.viewAddPosition && (
          <ModalPositions
            toggle={this.viewAddPositionModal}
            isOpen={this.state.viewAddPosition}
            currentPositions={this.props.data}
            addPosition={this.props.addPosition}
            groups={this.props.groups}
            patchPositions={this.props.patchPositions}
            editData={this.state.editData}
            permissions={this.props.permissions}
          />
        )}

        <div className="page-content">
        <ModifiedMetaTags title="Positions | Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItem="Positions"
              link="/dashboard"
            />
            {this.state.deleteAlert && (
              <SweetAlert
                showCancel
                confirmBtnText="Delete"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle=""
                title={this.state.deleteAlert.title}
                onCancel={() => this.handleChangeDeleteAlert(null)}
                onConfirm={this.state.deleteAlert.onConfirm}
              >
                <p>Are you sure want to delete this position?</p>
              </SweetAlert>
            )}

            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <RemoteTable
                      onTableChange={this.handleTableChange}
                      columns={columns}
                      data={this.props.data}
                      loading={this.props.loading}
                    >
                      {this.props.permissions?.["add_positionmodel"] && (
                        <Button
                          type="button"
                          color="success"
                          className="btn-rounded mb-2 me-2"
                          onClick={this.viewAddPositionModal}
                        >
                          <i className="mdi mdi-plus me-1" /> Add position
                        </Button>
                      )}
                    </RemoteTable>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const LegalNameLink = styled.div`
  transition-duration: 0.1s;
  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

PositionsList.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.object).isRequired,
  data: PropTypes.shape({
    page: PropTypes.number,
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired,
  permissions: PropTypes.object.isRequired,
  addPosition: PropTypes.func.isRequired,
  getPositionsList: PropTypes.func.isRequired,
  deletePosition: PropTypes.func.isRequired,
  getGroups: PropTypes.func.isRequired,
  patchPositions: PropTypes.func.isRequired,
  getPositionsById: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  groups: state.Positions.groups,
  data: state.Positions.data,
  loading: state.Positions.loading,
  permissions: state.User.permissions,
});

export default connect(mapStateToProps, {
  addPosition,
  getPositionsList,
  deletePosition,
  getGroups,
  getPositionsById,
  patchPositions,
})(PositionsList);
